import { Formatters } from '../modules'
import { constants } from '../shared'
import {
  FIELD_ROOM_ID,
  FIELD_PAYMENT,
  FIELD_TIME,
  FIELD_CONTRACT_CUSTOMER,
  FILTERS_SELECT_DATE,
  SUMMARY_SUM,
} from './_common'

function get_subjects1(that) {
  return that.$store.state.summary.subjectstree || {}
}

function get_subjects2(that, subject1) {
  return get_subjects1(that)[subject1] || {}
}

function get_subjects3(that, subject1, subject2) {
  return get_subjects2(that, subject1)[subject2] || {}
}

function contains(source, target) {
  if (!target)
    return true
  return source.toLowerCase().indexOf(target.toLowerCase()) >= 0
}

export default {
  props: {
    state: {
      label: '状态',
      type: 'state',
      classes: 'collapsing hide-in-mobile',
    },
    subject1: {
      label: '一级科目',
      type: 'autocomplete',
      suggestions(form) {
        return function (query, callback) {
          callback(Object.keys(get_subjects1(this)).map(value => ({ value })).filter(({ value }) => contains(value, query)))
        }
      },
      suggestions_handler(item) {
        this.form.subject1 = item.value
        this.form.subject2 = ''
        this.form.subject3 = ''
      }, 
    },
    subject2: {
      label: '二级科目',
      type: 'autocomplete',
      suggestions(form) {
        return function (query, callback) {
          callback(Object
            .keys(get_subjects2(this, form.subject1))
            .map(value => ({ value }))
            .filter(({ value }) => contains(value, query))
          )
        }
      },
      suggestions_handler(item) {
        this.form.subject2 = item.value
        this.form.subject3 = ''
      },
    },
    subject3: {
      label: '三级科目',
      type: 'autocomplete',
      suggestions(form) {
        return function (query, callback) {
          callback(Object
            .keys(get_subjects3(this, form.subject1, form.subject2))
            .map(value => ({ value }))
            .filter(({ value }) => contains(value, query))
          )
        }
      },
    },
    subjects: {
      label: '科目',
      formatter(_, record) {
        if (record.subject3)
          return `${record.subject1} - ${record.subject2} - ${record.subject3}`
        else if (record.subject2)
          return `${record.subject1} - ${record.subject2}`
        else if (record.subject1)
          return record.subject1
        return '无'
      },
      classes: 'collapsing hide-in-mobile',
    },
    _room: FIELD_ROOM_ID(),
    payment_method: FIELD_PAYMENT(),
    customers_summary: FIELD_CONTRACT_CUSTOMER(undefined, { maxlength: 3 }),
    action: {
      label: '操作',
      formatter: Formatters.bill_action,
      type: 'select',
      select: Object.entries(constants.bills.actions).map(([key, label]) => ({ key, label })),
      readonly: true,
      default: 'manual',
      classes: 'collapsing',
    },
    income_actual: {
      label: '收入',
      type: 'money',
      classes: 'right aligned positive',
      summary: SUMMARY_SUM('income_actual'),
      sortable: true,
    },
    income_due: {
      label: '应有收入',
      type: 'money',
      classes: 'right aligned positive',
      sortable: true,
    },
    outcome_actual: {
      label: '支出',
      type: 'money',
      classes: 'right aligned negative',
      summary: SUMMARY_SUM('outcome_actual'),
      sortable: true,
    },
    outcome_due: {
      label: '应有支出',
      type: 'money',
      classes: 'right aligned negative',
    },
    unit: {
      label: '单位',
      default: '笔',
    },
    unit_price: {
      label: '单价',
      type: 'money',
      sortable: true,
    },
    quantity: {
      label: '数量',
      type: 'number',
      default: 1,
      sortable: true,
    },
    detail: {
      label: '摘要',
      classes: 'collapsing hide-in-mobile',
    },
    note: {
      label: '备注',
      maxlength: 15,
      tooltip: true,
    },
    time_created: FIELD_TIME('time_created', { readonly: false }),
  },

  actions: {
    edit: {
      icon: 'pencil',
      tooltip: '编辑',
      permissions: 'basic.modify.bills',
    },
    print: {
      icon: 'print',
      tooltip: '打印',
      permissions: 'basic.modify.bills.print',
    },
    print_select: {
      icon: 'print',
      tooltip: '添加到打印列队',
      permissions: 'basic.modify.bills.print',
      classes: 'blue',
    },
    mark_verified: {
      icon: 'checkmark',
      tooltip: '审核通过',
      permissions: 'basic.modify.bills.verify',
    },
    mark_review: {
      icon: 'eye',
      tooltip: '确认',
      permissions: 'basic.modify.bills.review',
    },
    mark_invalid: {
      icon: 'remove',
      tooltip: '驳回',
      permissions: 'basic.modify.bills.verify',
    },
  },

  layouts: {
    default: {
      layout: [
        'state',
        'time_created',
        '_room',
        'customers_summary',
        'action',
        'detail',
        'subjects',
        'income_actual',
        'outcome_actual',
        'payment_method',
      ],
    },
    detail: {
      layout: [
        'state',
        '_room',
        'action',
        'subjects',
        'detail',
        'income_due',
        'income_actual',
        'outcome_due',
        'outcome_actual',
        'unit_price',
        'unit',
        'quantity',
        'payment_method',
        'time_created',
        'note',
      ],
    },
  },

  form: {
    create: {
      type: 'post',
      url: 'bills/manual',
      confirm: '确定添加账单？',
      loadOnSuccess: 'bills',
      default() {
        return {
          action: 'manual',
        }
      },
    },
    modify: {
      type: 'put',
      url() { return `bills/${this.form._id}` },
      confirm: '确定保存修改？',
      loadOnSuccess: 'bills',
    },
    layout: [
      ['action', 'subject1', 'subject2', 'subject3', 'detail', '_room'],
      ['quantity', 'unit', 'unit_price'],
      ['income_actual', 'outcome_actual', 'payment_method', 'time_created'],
      ['note'],
    ],
  },

  filters: {
    search: {
      type: 'search',
      keys: [
        '$_room',
        '$customers_summary',

        // '#income_actual',
        // '#outcome_actual',

        'subject1',
        'subject2',
        'subject3',
        'detail',
        '$action',
        '$payment_method',
        'note',
      ],
    },
    date: FILTERS_SELECT_DATE(),
    state: {
      type: 'select',
      default: 'pending',
      selects: [{
        name: 'all',
        label: '全部',
        filter: r => r,
      }, {
        name: 'verified',
        label: '已确认',
        filter: (r) => r.state === 'verified',
      }, {
        name: 'review',
        label: '待审核',
        filter: (r) => r.state === 'review',
      }, {
        name: 'pending',
        label: '待确认',
        filter: (r) => r.state === 'pending',
      }, {
        name: 'invalid',
        label: '已驳回',
        filter: (r) => r.state === 'invalid',
      }],
    },
    types: {
      type: 'select',
      selects: [{
        name: null,
        label: '全部',
      }, {
        name: 'charges',
        label: '水电',
        filter: (r) => r.subject2 === '水电费',
      }, {
        name: 'preorders',
        label: '预定金',
        filter: (r) => r.subject2 === '预定金',
      }, {
        name: 'rents',
        label: '租金',
        filter: (r) => r.subject2 === '租金',
      }, {
        name: 'desposits',
        label: '押金',
        filter: (r) => r.subject2 === '合同押金',
      }, {
        name: 'manage',
        label: '管理费',
        filter: (r) => r.subject2 === '管理费',
      }, {
        name: 'etc',
        label: '其他',
        filter: (r) => ['水电费', '预定金', '租金', '合同押金', '管理费'].indexOf(r.subject2) < 0,
      }],
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/bill.js